import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './routes/Root';
import React, { Suspense, lazy  } from "react"; 
import ScrollToTop from './helpers/ScrollToTop';
import HomePage from './pages/Home';
import { Helmet } from 'react-helmet';
import ProtezioneDeiDatiPage from './pages/ProtezioneDeiDati';
import NoteLegaliPage from './pages/NoteLegali';

function App() {

  
  const currentYear = new Date().getFullYear();
const metaContent = `Agenzie di Design dell'Esperienza Utente (UX) ${currentYear} - Go Digital`;

const NoteLegaliPage = lazy(() => import('./pages/NoteLegali'));
const ProtezioneDeiDatiPage = lazy(() => import('./pages/ProtezioneDeiDati'));

return (
  <>
    <Helmet>
      <title>{metaContent}</title>
      <meta name="keywords" content="Agenzie di Design UX, Agenzie di Esperienza Utente, Analisi di Mercato, Agenzie UI, Designer UX, Germania, Berlino, Amburgo, Francoforte, Monaco, Agenzie di Ricerca sugli Utenti, Consulenza sull'Esperienza Utente, Design dell'Interfaccia Utente, Consulenti di Usabilità" />
      <meta name="description" content="Risultati della classificazione delle migliori Agenzie di Design UX in Germania, iniziativa supportata dal Ministero Federale per l'Economia e la Protezione del Clima" />
      <meta name="title" content={metaContent} />
    </Helmet>
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path='/note-legali' element={
            <Suspense fallback={<div>Caricamento...</div>}>
              <NoteLegaliPage />
            </Suspense>
          } />
          <Route path='/protezione-dei-dati' element={
            <Suspense fallback={<div>Caricamento...</div>}>
              <ProtezioneDeiDatiPage />
            </Suspense>
          } />
        </Route>
      </Routes>
    </Router>
  </>
);
}

export default App;
